/* osi-2026.js — comportamiento de las secciones osi-* (OSI Papier 2026).
   Sin dependencias. Todo se engancha por atributos data-osi-*. */
(function () {
  if (window.__osi2026) return;
  window.__osi2026 = true;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Menú móvil */
  function initDrawer() {
    all('[data-osi-drawer-open]').forEach(function (btn) {
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      var close = drawer.querySelector('[data-osi-drawer-close]');
      function set(open) {
        drawer.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open && close) close.focus(); else btn.focus();
      }
      btn.addEventListener('click', function () { set(true); });
      if (close) close.addEventListener('click', function () { set(false); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    });
  }

  /* Pestañas que filtran tarjetas por línea (todos / crear / emprender) */
  function initTabs() {
    all('[data-osi-tabs]').forEach(function (root) {
      var tabs = all('[role="tab"]', root);
      var cards = all('[data-line]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var v = tab.getAttribute('data-value');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          cards.forEach(function (c) { c.hidden = !(v === 'todos' || c.getAttribute('data-line') === v); });
        });
      });
    });
  }

  /* Acordeón: una sola respuesta abierta a la vez */
  function initFaq() {
    all('[data-osi-faq]').forEach(function (root) {
      var items = all('.osi-faq__item', root);
      items.forEach(function (it) {
        var q = it.querySelector('.osi-faq__q');
        q.addEventListener('click', function () {
          var open = q.getAttribute('aria-expanded') !== 'true';
          items.forEach(function (o) {
            var oq = o.querySelector('.osi-faq__q'), oa = o.querySelector('.osi-faq__a');
            var on = o === it && open;
            oq.setAttribute('aria-expanded', on ? 'true' : 'false');
            oq.querySelector('.osi-faq__sign').textContent = on ? '−' : '+';
            oa.hidden = !on;
          });
        });
      });
    });
  }

  /* Vista previa en vivo: data-osi-preview contiene inputs [data-osi-in="x"] y salidas [data-osi-out="x"] */
  function initPreview() {
    all('[data-osi-preview]').forEach(function (root) {
      all('[data-osi-in]', root).forEach(function (inp) {
        var key = inp.getAttribute('data-osi-in');
        var outs = all('[data-osi-out="' + key + '"]', root);
        function sync() {
          outs.forEach(function (o) {
            var pre = o.getAttribute('data-prefix') || '';
            o.textContent = pre + (inp.value.trim() || o.getAttribute('data-default') || '');
          });
        }
        inp.addEventListener('input', sync);
      });
    });
  }

  /* Formularios: chips (únicos o múltiples) llenan un campo oculto; campos condicionales; validación */
  function initForms() {
    all('[data-osi-form]').forEach(function (root) {
      var form = root.querySelector('form');
      if (!form) return;
      form.noValidate = true;

      // Campos que aparecen según un grupo de chips: data-osi-show="grupo:valor"
      root.addEventListener('osi:change', function (e) {
        all('[data-osi-show^="' + e.detail.name + ':"]', root).forEach(function (el) {
          var want = el.getAttribute('data-osi-show').split(':').slice(1).join(':');
          var on = e.detail.values.indexOf(want) > -1;
          el.hidden = !on;
          all('input, textarea, select', el).forEach(function (i) { i.disabled = !on; });
        });
      });

      // Etiqueta y placeholder que cambian según el medio de contacto
      root.addEventListener('osi:change', function (e) {
        all('[data-osi-switch="' + e.detail.name + '"]', root).forEach(function (field) {
          var v = e.detail.values[0] || '';
          var alt = v === field.getAttribute('data-when');
          var label = field.querySelector('.osi-field__label');
          var input = field.querySelector('input');
          if (label) label.textContent = alt ? field.getAttribute('data-label-alt') : field.getAttribute('data-label');
          if (input) {
            input.placeholder = alt ? field.getAttribute('data-ph-alt') : field.getAttribute('data-ph');
            input.type = alt ? 'tel' : 'email';
            input.name = alt ? 'contact[WhatsApp]' : 'contact[email]';
            input.autocomplete = alt ? 'tel' : 'email';
          }
        });
      });

      all('[data-osi-chips]', root).forEach(function (group) {
        var multi = group.getAttribute('data-multi') === 'true';
        var hidden = form.querySelector('[name="' + group.getAttribute('data-osi-chips') + '"]');
        var chips = all('.osi-chip', group);
        function write() {
          var vals = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }).map(function (c) { return c.getAttribute('data-value'); });
          if (hidden) hidden.value = vals.join(' | ');
          root.dispatchEvent(new CustomEvent('osi:change', { detail: { name: group.getAttribute('data-osi-chips'), values: vals } }));
        }
        chips.forEach(function (c) {
          c.addEventListener('click', function () {
            var on = c.getAttribute('aria-pressed') === 'true';
            if (!multi) chips.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
            c.setAttribute('aria-pressed', on && multi ? 'false' : 'true');
            write();
          });
        });
        write();
      });

      // Enlaces externos que marcan una opción (p. ej. "Lo quiero para mi evento")
      all('[data-osi-pick]').forEach(function (a) {
        a.addEventListener('click', function () {
          var chip = root.querySelector('.osi-chip[data-value="' + a.getAttribute('data-osi-pick') + '"]');
          if (chip && chip.getAttribute('aria-pressed') !== 'true') chip.click();
          var msg = a.getAttribute('data-osi-message');
          var ta = msg && form.querySelector('textarea');
          if (ta && !ta.value.trim()) {
            var src = document.querySelector('[data-osi-message-source]');
            ta.value = msg.replace('{name}', src ? (src.textContent || '').trim() : '');
          }
        });
      });

      form.addEventListener('submit', function (e) {
        var bad = null;
        all('[data-osi-required]', form).forEach(function (inp) {
          var v = inp.value.trim();
          var ok = inp.type === 'email' ? /\S+@\S+\.\S+/.test(v) : inp.type === 'tel' ? v.replace(/\D/g, '').length >= 8 : v.length > 0;
          inp.setAttribute('aria-invalid', ok ? 'false' : 'true');
          var err = inp.parentNode.querySelector('.osi-field__error');
          if (err) err.hidden = ok;
          if (!ok && !bad) bad = inp;
        });
        if (bad) { e.preventDefault(); bad.focus(); return; }
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }

  /* Botón "Ver los volúmenes": desplazamiento suave hacia el ancla */
  function initScroll() {
    all('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 24, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  /* Confirmación de formularios (snippets/osi-confirm.liquid): arranca al entrar en pantalla.
     plumilla: traza el título con los glifos de osi-glifos-plumilla.js (window.OSI_GLYPHS). */
  var NIB = ['M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z', 'm18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18', 'm2.3 2.3 7.286 7.286', 'M13 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0z'];
  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(tag, attrs) { var el = document.createElementNS(SVGNS, tag); for (var k in attrs) el.setAttribute(k, attrs[k]); return el; }
  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  function playPen(root, box, G) {
    var title = box.getAttribute('data-osi-plumilla');
    var x = 0, total = 0, parts = [];
    Array.from(title).forEach(function (ch) { var g = G[ch] || G[' ']; parts.push({ g: g, x: x, start: total }); x += g.a; total += g.l; });
    if (!total) { root.classList.add('is-done'); return; }
    var svg = svgEl('svg', { viewBox: '-24 -110 ' + (x + 48).toFixed(1) + ' 150', 'aria-hidden': 'true', focusable: 'false' });
    parts.forEach(function (part) {
      if (!part.g.d) return;
      part.el = svgEl('path', { d: part.g.d, transform: 'translate(' + part.x + ',0)', 'class': 'g', 'vector-effect': 'non-scaling-stroke' });
      part.el.style.strokeDasharray = part.g.l + ' ' + (part.g.l + 1);
      part.el.style.strokeDashoffset = part.g.l;
      svg.appendChild(part.el);
    });
    var nib = svgEl('g', { 'class': 'osi-confirm__nib' });
    NIB.forEach(function (d, i) { var p = svgEl('path', { d: d, 'vector-effect': 'non-scaling-stroke' }); if (i === 0) p.style.fill = 'var(--paper-50)'; nib.appendChild(p); });
    svg.appendChild(nib);
    var line = document.createElement('span'); line.className = 'osi-confirm__line';
    box.innerHTML = ''; box.style.width = 'min(100%, ' + Math.max(220, Math.round(x * .95)) + 'px)';
    box.setAttribute('aria-label', title); box.setAttribute('role', 'img');
    box.appendChild(svg); box.appendChild(line);

    function draw(p) {
      var at = p * total, nx = 0, ny = 0;
      parts.forEach(function (part) {
        var g = part.g; if (!g.l) return;
        var local = Math.max(0, Math.min(1, (at - part.start) / g.l));
        if (part.el) part.el.style.strokeDashoffset = g.l * (1 - local);
        if (at >= part.start) { var i = Math.round(local * (g.p.length / 2 - 1)); nx = g.p[i * 2] + part.x; ny = g.p[i * 2 + 1]; }
      });
      nib.setAttribute('transform', 'translate(' + nx.toFixed(1) + ',' + ny.toFixed(1) + ') scale(1.7,-1.7) translate(-2.3,-2.3)');
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { draw(1); root.classList.add('is-done'); return; }
    var dur = Math.min(4200, Math.max(2200, total * .5)), t0 = null;
    draw(0);
    requestAnimationFrame(function frame(now) {
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / dur);
      draw(ease(t));
      if (t < 1) requestAnimationFrame(frame); else root.classList.add('is-done');
    });
  }

  function initConfirm() {
    all('[data-osi-confirm]').forEach(function (root) {
      var box = root.querySelector('[data-osi-plumilla]');
      root.classList.add('is-armed');
      function go() {
        root.classList.add('is-play');
        if (!box) return;
        var tries = 0;
        (function wait() {
          if (window.OSI_GLYPHS) return playPen(root, box, window.OSI_GLYPHS);
          if (tries++ < 40) setTimeout(wait, 50); else root.classList.add('is-done');
        })();
      }
      if (!('IntersectionObserver' in window)) return go();
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); go(); }
      }, { threshold: .35 });
      io.observe(root);
    });
  }

  /* Carrito: no deja pasar al pago sin aceptar los términos */
  function initCart() {
    all('[data-osi-cart]').forEach(function (form) {
      var box = form.querySelector('[data-osi-terms]'), err = form.querySelector('[data-osi-terms-error]');
      if (!box) return;
      form.noValidate = true;
      box.addEventListener('change', function () { if (box.checked && err) err.hidden = true; });
      form.addEventListener('submit', function (e) {
        if (box.checked) return;
        e.preventDefault(); if (err) err.hidden = false; box.focus();
      });
    });
  }

  /* ¿Cuál me toca?: tres pasos, el tercero depende de la línea elegida en el primero */
  function initQuiz() {
    all('[data-osi-quiz]').forEach(function (root) {
      var ask = root.querySelector('[data-osi-quiz-ask]'), done = root.querySelector('[data-osi-quiz-done]');
      var steps = all('.osi-quiz__step', root), back = root.querySelector('[data-osi-quiz-back]');
      var cards = all('[data-result]', root), a = [];
      root.classList.add('is-ready');
      function render(focus) {
        var n = a.length;
        ask.hidden = n >= 3; done.hidden = n < 3;
        if (n < 3) {
          root.querySelector('[data-osi-quiz-n]').textContent = n + 1;
          root.querySelector('[data-osi-quiz-bar]').style.width = Math.round(n / 3 * 100) + '%';
          steps.forEach(function (st) {
            var on = +st.getAttribute('data-step') === n && (!st.hasAttribute('data-line') || st.getAttribute('data-line') === a[0]);
            st.hidden = !on;
            if (on && focus) st.querySelector('.osi-quiz__q').focus();
          });
          back.hidden = n === 0;
        } else {
          var shown = null;
          cards.forEach(function (c) { var on = !shown && c.getAttribute('data-result') === a[2]; c.hidden = !on; if (on) shown = c; });
          root.querySelector('[data-why-cero]').hidden = a[1] !== 'cero';
          root.querySelector('[data-why-mano]').hidden = a[1] === 'cero';
          if (shown && focus) shown.querySelector('.osi-quiz__name').focus();
        }
      }
      all('[data-pick]', root).forEach(function (b) { b.addEventListener('click', function () { a.push(b.getAttribute('data-pick')); render(true); }); });
      back.addEventListener('click', function () { a.pop(); render(true); });
      root.querySelector('[data-osi-quiz-restart]').addEventListener('click', function () { a = []; render(true); });
      render(false);
    });
  }

  /* Pruébalo (Atelier): el chip cambia el formato del papel y la etiqueta de la segunda línea */
  function initTry() {
    all('[data-osi-try]').forEach(function (root) {
      var paper = root.querySelector('.osi-try__paper'), label = root.querySelector('[data-osi-try-label]');
      var inp = root.querySelector('[data-osi-in="line"]'), out = root.querySelector('[data-osi-out="line"]');
      var chips = all('[data-kind]', root).filter(function (c) { return c.tagName === 'BUTTON'; });
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
          paper.setAttribute('data-kind', c.getAttribute('data-kind'));
          label.textContent = c.getAttribute('data-label');
          inp.placeholder = c.getAttribute('data-ph'); inp.value = '';
          out.setAttribute('data-default', c.getAttribute('data-def'));
          out.textContent = c.getAttribute('data-def');
        });
      });
    });
  }

  /* Diagnóstico de Mentoría: 4 preguntas de una opción; la tarjeta muestra el resultado al contestar todas */
  function initDiag() {
    all('[data-osi-diag]').forEach(function (root) {
      var qs = all('[data-q]', root), ans = {};
      var pending = root.querySelector('[data-pending]'), count = root.querySelector('[data-count]');
      var results = all('[data-result]', root);
      function update() {
        var n = Object.keys(ans).length;
        count.textContent = n;
        var key = null;
        if (n === qs.length) {
          var last1 = qs[0].querySelectorAll('[data-opt]').length;
          if (ans[1] === last1) key = 'volumen';
          else if (ans[3] === 1) key = 'uno';
          else if (ans[3] === 2) key = 'tres';
          else key = 'medio';
        }
        pending.hidden = !!key;
        results.forEach(function (r) { r.hidden = r.getAttribute('data-result') !== key; });
      }
      qs.forEach(function (q) {
        var n = +q.getAttribute('data-q'), chips = all('[data-opt]', q);
        chips.forEach(function (c) {
          c.addEventListener('click', function () {
            chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
            ans[n] = +c.getAttribute('data-opt'); update();
          });
        });
      });
    });
  }

  ready(function () { initDiag(); initTry(); initQuiz(); initCart(); initDrawer(); initTabs(); initFaq(); initPreview(); initForms(); initScroll(); initConfirm(); });
})();
